import { getAllDiagnosis } from '@uplift/api';
import { useCallback } from 'react';


export const useDiagnoses = () => {
  const fetchDiagnoses = useCallback(async () => {
    const diagnosesResponse = await getAllDiagnosis();

    return diagnosesResponse.data;
  }, []);

  return { fetchDiagnoses };
};
